import { render } from "./Sobre.vue?vue&type=template&id=6a3a28e1&scoped=true&ts=true"
import script from "./Sobre.vue?vue&type=script&lang=ts"
export * from "./Sobre.vue?vue&type=script&lang=ts"

import "./Sobre.vue?vue&type=style&index=0&id=6a3a28e1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a3a28e1"]])

export default __exports__